
import { openReactConfirmationDialog } from '~commonInfra/dialogs/ReactConfirmationDialog';
import { TabDialogWidth } from '~commonInfra/dialogs/style/TabDialogWidth';
import { Messages } from '~src/codegen/Localize';
import { L10n } from '~src/commonInfra/L10n/L10n';
import { ToasterService,ToastType } from '~src/commonInfra/services/ToasterService';

import { IUpdateBaasPoolServiceTokensResult } from '../../serverApi/requests/UpdateBaasPoolServiceTokensRequest';
import { BaasEdgePoolAndCluster } from '../../serverApi/resources/BaasEdgePoolAndCluster';
import { ActionItemInfo } from '../MoreActionsMenu';
import { getGeneralErrorMessage } from '../utils/EdgePoolErrorUtilities';


export function openRefreshTokensDialog(actionItem: ActionItemInfo) {
  const { poolId, poolName, refreshPoolsAndClusters } = actionItem;
  const dialogInstance = openReactConfirmationDialog({
    title: Messages.dataConnectSiteSettingsRefreshTokensButton(),
    message: Messages.dataConnectSiteSettingsRefreshTokensDescription({ NAME: L10n.elideIfLong(poolName) }),
    paramsForAction: { poolId: poolId},
    actionName: Messages.confirm(),
    action: () => {
      return  BaasEdgePoolAndCluster.updateBaasPoolServiceTokens({poolId: poolId})
      .then((result: IUpdateBaasPoolServiceTokensResult) => {
        refreshPoolsAndClusters();
        if (result.success) {
          ToasterService.instance.pop({ type: ToastType.Success, text: Messages.dataConnectSiteSettingsRefreshTokensSuccess({ NAME: L10n.elideIfLong(poolName) }) });
        }
        if (result.errors) {
          ToasterService.instance.pop({
            type: ToastType.Error,
            text: getGeneralErrorMessage(result.errors[0].code, result.errors[0].message)
          });
        }
        return Promise.resolve({});
      });
    },
    isActionDelete: false,
    dialogWidth: TabDialogWidth.width375px
  });

  return Promise.resolve(dialogInstance.result);
}
